import { graphql } from "relay-runtime"

export const chMeasLaboratoryPrescriptionFragment = graphql`
  fragment chMeasLaboratoryPrescriptionFragment on ch_MeasLaboratoryPrescription {
    id
    createdAt
    createdBy
    fileId
    language
    patientId
    progressNoteId
    signedAt
    signedBy
    updatedAt
    updatedBy
    sentAt
    sentBy
    concludedAt
    concludedBy
    fileMetadata {
      documentType
      extension
      lengthInKilobytes
    }
    bloodChemistries
    coagulations
    hematologies
    urineDiagnostics
    rapidTests
  }
`
